<!--
 * @title: 页面名称
 * @Description: 
 * @Version: 2.0
 * @Autor: 研发三部
 * @Date: 2020-12-03 09:37:11
 * @LastEditors: wch
 * @LastEditTime: 2020-12-28 16:01:28
-->
<template>
    <div class="atlas_view"
        style="height: 100%;">

        <el-scrollbar style="width: 100%; background-color: black;height: 100%;overflow-x:hidden" v-if="!flag">

        <div style="width: 80%; margin: 0 auto;height: 100%;background-color: #e2d3d3;" >
            <el-row :gutter="6" style="background-color: #e2d3d3;" >
                <el-col :span="6" v-for="(item, index) in atlas" shadow="hover" style="margin-bottom: 6px;"
                    @click="viewCarousel(index)">

                    <div 
                        style="height: 200px;display: flex;align-items: center;justify-content: center;background-color: #fff;"
                        @click="viewCarousel(index)">
                        <div style="height: 100%;width: 100%;">
                            <el-image :src="item.url" v-if="item.contentType == 'image'"
                        style="width: 100%; height: 200px" fit="contain"></el-image>
                            <div style="display: flex;align-items: center;justify-content: center;">
                                <video     autoPlay     :src=" item.url" v-if="item.contentType == 'video'" @click="viewCarousel(index)"
                            preload="auto" muted loop  height="200" style="width: 100%;"></video>

                            </div>
                           

                        </div>
                        
                    </div>

                </el-col>
            </el-row>

        </div>


    </el-scrollbar>



        <div style="width: 100%; height: 100%" v-else-if="flag">
            <el-carousel :autoplay="false" arrow="always" style="width: 100%;height: 100%" :initial-index="initialIndex" @change="carouselChang"	 >
                <el-carousel-item v-if="atlas && atlas.length > 0" v-for="(item,index) in atlas"
                    style="width: 100%; height: 100%">
                    <el-image :src=" item.url" v-if="item.contentType == 'image'"
                        style="width: 100%; height: 100%" fit="contain"></el-image>
                        
                    <video :src=" item.url"  v-if="item.contentType == 'video' " controls="controls"
                         style="height: 100%;width: 100%;" preload="auto" :ref="'vueMiniPlayer'+index" ></video>
                </el-carousel-item>
                <el-button class="closeButton" style="z-index: 10;" circle @click="viewCard">
                    <i class="el-icon-close"></i>
                </el-button>
            </el-carousel>

        </div>



        <span class="home-button" v-if="homeButton=='show'">
            <el-button @click="skipHome" icon="el-icon-s-home" circle></el-button>
        </span>

    </div>
</template>
<script>

import * as api from "@/api/cloud-screen";
import CFG from "@/config/config";

import QRCode from 'qrcodejs2'



export default {
    components: {

    },
    props: {
        shouyeBackdropImage: {
            type: Array, default: function () {
                return [] // 或者[]
            }
        },
        shouyeIcon: {
            type: Array, default: function () {
                return [] // 或者[]
            }
        },

    },
    data() {
        return {
            urlprefix: CFG.LOTIP,

            fileList3: [
                {
                    url: "/large-screen/pest/cymc.jpg",
                    type: "image"
                },
                {
                    url: "/large-screen/pest/gymg.jpg",
                    type: "image"
                },
                {
                    url: "/large-screen/atlas/1.mp4",
                    type: "video"
                },

                {
                    url: "/large-screen/pest/gyfs.jpg",
                    type: "image"
                },
                {
                    url: "/large-screen/atlas/3.mp4",
                    type: "video"
                },
                {
                    url: "/large-screen/atlas/2.mp4",
                    type: "video"
                },

                {
                    url: "/large-screen/pest/hztw.jpg",
                    type: "image"
                },
                {
                    url: "/large-screen/atlas/4.mp4",
                    type: "video"
                },
                {
                    url: "/large-screen/pest/cymc.jpg",
                    type: "image"
                },
                {
                    url: "/large-screen/pest/gymg.jpg",
                    type: "image"
                },
                {
                    url: "/large-screen/atlas/1.mp4",
                    type: "video"
                },

                {
                    url: "/large-screen/pest/gyfs.jpg",
                    type: "image"
                },
                {
                    url: "/large-screen/atlas/3.mp4",
                    type: "video"
                },
                {
                    url: "/large-screen/atlas/2.mp4",
                    type: "video"
                },

                {
                    url: "/large-screen/pest/hztw.jpg",
                    type: "image"
                },
                {
                    url: "/large-screen/atlas/4.mp4",
                    type: "video"
                },
                {
                    url: "/large-screen/pest/cymc.jpg",
                    type: "image"
                },
                {
                    url: "/large-screen/pest/gymg.jpg",
                    type: "image"
                },
                {
                    url: "/large-screen/atlas/1.mp4",
                    type: "video"
                },

                {
                    url: "/large-screen/pest/gyfs.jpg",
                    type: "image"
                },
                {
                    url: "/large-screen/atlas/3.mp4",
                    type: "video"
                },
                {
                    url: "/large-screen/atlas/2.mp4",
                    type: "video"
                },

                // {
                //     url: "/large-screen/pest/hztw.jpg",
                //     type: "image"
                // },
                // {
                //     url: "/large-screen/atlas/4.mp4",
                //     type: "video"
                // },
                // {
                //     url: "/large-screen/pest/cymc.jpg",
                //     type: "image"
                // },
                // {
                //     url: "/large-screen/pest/gymg.jpg",
                //     type: "image"
                // },
                // {
                //     url: "/large-screen/atlas/1.mp4",
                //     type: "video"
                // },

                // {
                //     url: "/large-screen/pest/gyfs.jpg",
                //     type: "image"
                // },
                // {
                //     url: "/large-screen/atlas/3.mp4",
                //     type: "video"
                // },
                // {
                //     url: "/large-screen/atlas/2.mp4",
                //     type: "video"
                // },

                // {
                //     url: "/large-screen/pest/hztw.jpg",
                //     type: "image"
                // },
                // {
                //     url: "/large-screen/atlas/4.mp4",
                //     type: "video"
                // },
                // {
                //     url: "/large-screen/pest/cymc.jpg",
                //     type: "image"
                // },
                // {
                //     url: "/large-screen/pest/gymg.jpg",
                //     type: "image"
                // },
                // {
                //     url: "/large-screen/atlas/1.mp4",
                //     type: "video"
                // },

                // {
                //     url: "/large-screen/pest/gyfs.jpg",
                //     type: "image"
                // },
                // {
                //     url: "/large-screen/atlas/3.mp4",
                //     type: "video"
                // },
                // {
                //     url: "/large-screen/atlas/2.mp4",
                //     type: "video"
                // },

                // {
                //     url: "/large-screen/pest/hztw.jpg",
                //     type: "image"
                // },
                // {
                //     url: "/large-screen/atlas/4.mp4",
                //     type: "video"
                // },
                // {
                //     url: "/large-screen/pest/cymc.jpg",
                //     type: "image"
                // },
                // {
                //     url: "/large-screen/pest/gymg.jpg",
                //     type: "image"
                // },
                // {
                //     url: "/large-screen/atlas/1.mp4",
                //     type: "video"
                // },

                // {
                //     url: "/large-screen/pest/gyfs.jpg",
                //     type: "image"
                // },
                // {
                //     url: "/large-screen/atlas/3.mp4",
                //     type: "video"
                // },
                // {
                //     url: "/large-screen/atlas/2.mp4",
                //     type: "video"
                // },

                // {
                //     url: "/large-screen/pest/hztw.jpg",
                //     type: "image"
                // },
                // {
                //     url: "/large-screen/atlas/4.mp4",
                //     type: "video"
                // },
               



            ],
            fileList33: [
                "/large-screen/pest/cymc.jpg",
                "/large-screen/pest/gymg.jpg",
                "/large-screen/pest/gyfs.jpg",
                "/large-screen/pest/gyst.png",
                "/large-screen/pest/hhjd.jpeg",
                "/large-screen/pest/hztw.jpg",
                "/large-screen/pest/jwjd.jpeg",
                "/large-screen/pest/jd.jpg",
                "/large-screen/pest/ylh.jpg",
                "/large-screen/pest/lxjd.jpg",

                // "/large-screen/pest/lxjd.jpg",



                "/large-screen/pest/mxg.jpg",
                "/large-screen/pest/pzyhh.jpg",
                "/large-screen/pest/qj.jpg",
                "/large-screen/pest/qhts.png",
                "/large-screen/pest/rxld.png",
                "/large-screen/pest/tbc.jpg",
                "/large-screen/pest/jgz.jpg",

                "/large-screen/atlas/1.mp4",


            ],
            shouyeBackdropImage1: [],
            shouyeIcon1: [],
            dialogVisible: false,
            qrcode: null,
            timerId: null,
            count: 0, // 用于计数的数据属性
            icon_box_width: '',
            flag: false,
            initialIndex: null,
            activeIndex:null,
            atlas:[],
            homeButton:'show'
        };
    },
    watch: {},
    async mounted() {
        if(this.$route.query && this.$route.query.homeButton){
          this.homeButton="hide"==this.$route.query.homeButton?'hide':'show'
        }
        this.getAtlas()

    },
    methods: {
        getAtlas() {
            api.getMediaCapitals(this.$route.params.systemSid).then(res => {
                if (res.resp_code == "10000") {
                    this.atlas=res.data


                }
            });
        },

        
        carouselChang(newIndex,oldIndex){
            console.log(newIndex,oldIndex)
            this.activeIndex=newIndex
            // this.$refs.vueMiniPlayer.pause();
            console.log(this.$refs['vueMiniPlayer'+oldIndex])
            console.log(this.$refs['vueMiniPlayer'+newIndex])


            if( this.$refs['vueMiniPlayer'+oldIndex]){
                this.$refs['vueMiniPlayer'+oldIndex][0].pause();
            }
            if( this.$refs['vueMiniPlayer'+newIndex]){
                this.$refs['vueMiniPlayer'+newIndex][0].play();
            }
            


            console.log(this.activeIndex)

        },
        skipHome() {
            this.$router.push("/cloud_screen/" + this.$route.params.systemSid);
        },
        viewCard() {
            this.flag = false
            this.initialIndex = null
        },
        viewCarousel(index) {
           
            this.initialIndex = index
            this.flag = true
            console.log(index)

            console.log(this.$refs['vueMiniPlayer'+index])

            this.$nextTick(item=>{
                if( this.$refs['vueMiniPlayer'+index]){
                this.$refs['vueMiniPlayer'+index][0].play();
            }
            })


        },
        generateQRCode() {
            this.$nextTick(item => {
                if (this.qrcode != null) {
                    this.qrcode.clear() // 清除原来的二维码
                }
                console.log(this.$refs.qrcodeDialog)
                console.log(this.$refs.qrcode)
                this.qrcode = new QRCode(this.$refs['qrcode'], {

                    text: this.$route.params.systemSid
                })

            })

        },
        handleClose() {
            this.dialogVisible = false

        },
        sortKey(array, key) {
            return array.sort(function (a, b) {
                var x = a[key];
                var y = b[key];
                return ((x < y) ? -1 : (x > y) ? 1 : 0)
            })
        },
        getTemp() {
            this.shouyeBackdropImage1 = []

            api.getTemp(this.$route.params.systemSid).then(res => {
                if (res.resp_code == "10000") {
                    console.log(res.data, "==================")

                    if (res.data) {
                        let arr = []
                        let obj1 = { name: "草原一张图", url: "/large-screen/" + this.$route.params.systemSid, status: 0, icon: '/large-screen/icon/cy.png', sort: 1, type: 'system' }
                        let obj2 = { name: "自定义", url: '', status: 0, icon: '', sort: 2, type: 'costom' }
                        let obj3 = { name: "自定义", url: '', status: 0, icon: '', sort: 3, type: 'costom' }
                        let obj4 = { name: "自定义", url: '', status: 0, icon: '', sort: 4, type: 'costom' }
                        let obj5 = { name: "自定义", url: '', status: 0, icon: '', sort: 5, type: 'costom' }
                        this.temp = res.data
                        if (res.data) {

                            if (res.data.shouyeIcon) {
                                arr = JSON.parse(res.data.shouyeIcon)
                            } else {
                                arr.push(obj1)
                                arr.push(obj2)
                                arr.push(obj3)
                                arr.push(obj4)
                                arr.push(obj5)
                            }

                            if (res.data.shouyeBackdropImage) {
                                this.shouyeBackdropImage1 = JSON.parse(res.data.shouyeBackdropImage)
                            } else {
                                this.shouyeBackdropImage1 = []
                            }


                        } else {
                            arr.push(obj1)
                            arr.push(obj2)
                            arr.push(obj3)
                            arr.push(obj4)
                            arr.push(obj5)
                            this.shouyeBackdropImage1 = []
                        }
                        this.shouyeIcon1 = this.sortKey(arr, 'sort')
                    }
                }
            });
        },


        skipUrl(item) {

            if (item.url) {
                if (item.type == 'system') {
                    this.$router.push(item.url)
                } else {
                    window.open(item.url, "_blank");
                }

            } else {
                this.$message.info("该图标未绑定资源！")
            }

        },

        // skipUrl(url) {
        //     if (url) {
        //         window.open(url, "_blank");
        //     } else {
        //         this.$message.info("该图标未绑定资源！")
        //     }

        // },
        changeActiveComponents(val) {
            //修改父组件传来的值
            this.$emit("changeActiveComponents", val);
        },

        getPestData(ids) {
            api.getPestData(ids).then((res) => {
                if (res.resp_code == "10000") {
                    let obj = res.data
                    this.fileList = obj['鼠害']
                    this.fileList1 = obj['虫害']
                    this.fileList2 = obj['毒害草']
                }
            });



        },

        getAreaAndType() {
            api.getAreaAndType(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    this.areaAndType.grasslandArea = res.data.grasslandArea
                        ? res.data.grasslandArea
                        : "-";
                    this.areaAndType.grasslandType = res.data.grasslandType
                        ? res.data.grasslandType
                        : "-";
                    this.areaAndType.rangeland = res.data.rangeland ? res.data.rangeland : "-";
                }
            });
        },
        getRangelandChart() {
            api.getRangelandChart(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    this.rangelandChart.xAxis.data = res.data.x;
                    this.rangelandChart.series.data = res.data.y;
                }
            });
        },
        getTypeChart() {
            api.getTypeChart(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    this.typeChart.xAxis.data = res.data.x;
                    this.typeChart.series.data = res.data.y;
                }
            });
        },
        getGrasslandGradeChart() {
            api.getGrasslandGradeChart(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    this.grasslandGradeChart.category = res.data.x;
                    this.grasslandGradeChart.lineData = res.data.y;
                }
            });
        },
        getGrasslandClassChart() {
            api.getGrasslandClassChart(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    this.grasslandClassChart.xAxis.data = res.data.x;
                    this.grasslandClassChart.series.data = res.data.y;
                }
            });
        },

        // getDegradationChart() {
        //   api.getDegradationChart(this.$route.params.systemSid).then((res) => {
        //     if (res.resp_code == "10000") {
        //       console.log(res.data,"pppppppppppppppp")
        //       this.grasslandClassChart.category = res.data.x;
        //       this.grasslandClassChart.lineData = res.data.y;
        //       this.degradationArea=res.data.area.sum
        //     }
        //   });
        // },

        getDegradationChart() {
            api.getDegradationChart(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    // this.degradationChart.xData = res.data.legend;
                    this.degradationChart.series[0].data = res.data.data;
                    this.degradationArea = res.data.area ? res.data.area.sum.toFixed(2) : "-";
                }
            });
        },

        getVegetationCoverageChart() {
            api.getVegetationCoverageChart(this.$route.params.systemSid).then((res) => {
                if (res.resp_code == "10000") {
                    this.vegetationCoverageChart.xAxis.data = res.data.x;
                    this.vegetationCoverageChart.series.data = res.data.y;
                    this.avgCoverage = res.data.avgCoverage
                        ? res.data.avgCoverage.avgCoverage.toFixed(2)
                        : "-";
                }
            });
        },
    },
};
</script>
  
<style lang="scss" scoped>
.atlas_view .el-row{
    margin:  0 !important;
}
.atlas_view /deep/ .el-scrollbar__view{
    height: 100%
}
.atlas_view /deep/ .el-scrollbar__wrap{
    overflow-x:hidden
}

.home-button {
    z-index: 10;
    position: absolute;
    left: 1%;
    bottom: 5%;
    right: 0;
    height: 80px;
    line-height: 80px;

    background-position: center;
    background-repeat: no-repeat;
    width: 0;
    /*background-size: "contain"*/
}

.home-button /deep/ .el-button--default:hover {
    background: rgba(255, 255, 255, 0.6) !important;
}

.home-button /deep/ .el-button {
    font-size: 1.8vw;
}

.home-button /deep/ .el-button--default {
    background: rgba(255, 255, 255, 0.8) !important;
    color: #5c5959 !important;
    border: none;

}

.home-button /deep/ .el-button.is-circle {
    padding: 5px;
}

.atlas_view /deep/ .el-carousel__container {
    height: 100%;
    width: 100%;

}


.atlas_view /deep/ .el-carousel__arrow--left {
    left: 165px;
}

.atlas_view /deep/ .el-carousel__arrow--right {
    right: 180px;
}

.atlas_view /deep/ .el-carousel__arrow {
    width: 54px;
    height: 54px;
    background-color: rgba(0, 0, 0, .4);
    font-size: 2vw;
    font-weight: 800;
}

.atlas_view /deep/ .closeButton {
    width: 54px;
    height: 54px;
    background-color: rgba(0, 0, 0, .4) !important;
    font-size: 2vw;
    font-weight: 800;
    position: absolute;
    top: 5%;
    right: 5%;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
}

.atlas_view /deep/ .el-carousel__indicators--horizontal {
    display: none;
}

// .text_center_1 {
//     font-size: 24px;
//     font-family: PingFang SC;
//     font-weight: 400;
//     color: #fff;
//     margin-top: 18px;
// }

// .icon_box1 {
//     position: relative;
//     -webkit-box-align: center;
//     align-items: center;
//     -webkit-box-orient: vertical;
//     -webkit-box-direction: normal;
//     flex-direction: column;
//     display: flex;
// }

// .icon_box {
//     height: 100px;
//     display: -webkit-box;
//     display: -ms-flexbox;
//     display: flex;
//     color: #fff;
//     cursor: pointer;
//     -webkit-box-align: center;
//     -ms-flex-align: center;
//     align-items: center;
//     margin-right: 5%;
//     // border: 1px red solid;
// }

// .carousel__icon .icon_box:nth-last-child(1) {
//     margin-right: 0% !important;
// }

// .carousel__icon {
//     position: absolute;
//     bottom: 40px;
//     z-index: 99;
//     width: 100%;
//     background: rgba(0, 0, 0, .4);
//     padding: 10px 0 10px;
// }

// .home_view /deep/ .el-carousel__indicators--horizontal{
//     display: none;
// }

// .home_view /deep/ .el-carousel__container {
//     height: 100%;
//     width: 100%;

// }

// .home_view /deep/ .el-carousel__arrow--left {
//     left: 165px;
// }

// .home_view /deep/ .el-carousel__arrow--right {
//     right: 180px;
// }

// .home_view /deep/ .el-carousel__arrow{
//     width: 54px;
//     height: 54px;
//     background-color: rgba(0,0,0,.4);
//     font-size: 2vw;
//     font-weight: 800;
// }
</style>

<style>
/* .image-slot1 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #d7dde7;
    font-size: 14px;
    font-size: 12vw;
}

.image-slot2 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #d7dde7;
    font-size: 14px;
    font-size: 2vw;
} */
</style>
  